module.exports = __webpack_public_path__ + "img/arrow-up.db2e0876.svg";